export const APPS = [
    "console",
    "modeler",
    "tasklist",
    "operate",
    "optimize",
    "identity",
];
export const getReadableAppName = (appName) => appName.charAt(0).toUpperCase() + appName.slice(1);
export const isTrialExpired = (org) => {
    return org.salesPlan?.trialExpired || false;
};
export const getOrgSalesPlan = (org) => {
    return org.salesPlan?.type;
};
export const canUpgradePlan = (org) => {
    const orgSalesPlan = getOrgSalesPlan(org);
    return ((orgSalesPlan === "free" || orgSalesPlan === "trial") &&
        org.permissions.org.billing.update);
};
export const canCreateCluster = (org) => {
    return (org.permissions.org.clusters.create ||
        (getOrgSalesPlan(org) === "paid-cc" && org.permissions.org.billing.update));
};
